module.exports = __webpack_public_path__ + "img/loudspeaker.36328164.svg";